<template>
  <div>
    <CRow>
      <CCol sm="12">
        <VehiclesCatalogTable
          :items="assets"
          :pagination-data="pagination"
          hover
          striped
          small
          fixed
          caption="Inventario de Vehículos"
          @refreshItems="refreshItems"
        />
      </CCol>
    </CRow>
  </div>
</template>

<script>
import VehiclesCatalogTable from '../../components/assets/VehiclesCatalogTable.vue'
import ws from '../../services/vehicles';
import store from '../../store'

export default {
  name: 'VehiclesCatalog',
  components: { VehiclesCatalogTable },
  data: function () {
		return {
            assets: [],
            pagination: {
              currentPage: 1,
              totalPages: 1,
              totalItems: 0,
              perPage: 30,
            },
            activeFilters: {}
        }
  },
  mounted: async function() {
    await this.refreshItems({ filters: {}, page: 1 });
  },
  methods: {
    async refreshItems (payload){
      this.loading();
        let filters = {};
        let page = 1;
        let prioritizeNew = false;
        let pinItem = null;

        if(payload && payload.filters !== undefined){
          filters = payload.filters || {};
          page = payload.page || 1;
          prioritizeNew = !!payload.prioritizeNew;
          pinItem = payload.pinItem || null;
        }
        else{
          filters = payload || {};
        }

        this.activeFilters = filters;

        let requestData = {
          ...filters,
          page: page,
          per_page: this.pagination.perPage,
        };

        let response = await ws.get(requestData);
        if(response.type == "success"){
          const data = response.data || {};
          let items = data.data || [];

          if (prioritizeNew && pinItem && pinItem.id) {
            const pinId = Number(pinItem.id);
            items = [pinItem].concat(items.filter(item => Number(item.id) !== pinId));
            items = items.slice(0, this.pagination.perPage);
          }

          this.assets = items;
          this.pagination = {
            ...this.pagination,
            currentPage: data.current_page || 1,
            totalPages: data.last_page || 1,
            totalItems: data.total || 0,
          };
        }
      this.loaded();
    },
    loading(){
      store.commit('loading');
    },
    loaded(){
      store.commit('loaded');
    }
  }
}
</script>
